import {
  createSelector,
  createFeatureSelector,
  ActionReducerMap,
  ActionReducer,
  MetaReducer,
} from '@ngrx/store';
import { environment } from 'src/environments/environment';
import * as fromDrawer from './drawers/reducers';

export const reducers: ActionReducerMap<any> = {
  drawer: fromDrawer.reducer,
};

export function logger(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state: any, action: any): any => {
    const result = reducer(state, action);
    console.groupCollapsed(action.type);
    console.log('prev state', state);
    console.log('action', action);
    console.log('next state', result);
    console.groupEnd();
    return result;
  };
}

export const metaReducers: MetaReducer<any>[] = !environment.production ? [logger] : [];

export const getDrawerState = createFeatureSelector<any>('drawer');

export const getDrawers = createSelector(getDrawerState, fromDrawer.getdrawerState);
